import { Zap, Sparkles, Clock } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const Facilities = () => {
  const { t } = useLang();
  const facilities = [
    { id: "wifi", icon: Zap, titleKey: "fac_wifi_title", textKey: "fac_wifi_text" },
    { id: "housekeeping", icon: Sparkles, titleKey: "fac_house_title", textKey: "fac_house_text" },
    { id: "reception", icon: Clock, titleKey: "fac_rec_title", textKey: "fac_rec_text" },
  ];
  return (
    <section
      id="facilities"
      data-testid="facilities-section"
      className="relative py-24 lg:py-32"
      style={{ background: "linear-gradient(180deg, #0b0c10 0%, #0d1013 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <div className="text-xs font-heading tracking-[0.3em] text-[#00FF66] uppercase mb-4">
            {t("fac_kicker")}
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-extrabold text-white leading-[1.05]">
            {t("fac_title")}
          </h2>
          <p className="text-[#9CA3AF] mt-5">{t("fac_lead")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {facilities.map((f) => (
            <div
              key={f.id}
              data-testid={`facility-card-${f.id}`}
              className="facility-card p-8 rounded-2xl group relative overflow-hidden"
            >
              <div
                className="absolute -top-16 -right-16 w-40 h-40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{
                  background:
                    "radial-gradient(circle, rgba(0,255,102,0.15) 0%, rgba(0,255,102,0) 70%)",
                }}
              />
              <div className="relative">
                <div className="w-14 h-14 rounded-xl bg-[rgba(0,255,102,0.1)] border border-[rgba(0,255,102,0.3)] flex items-center justify-center mb-6 group-hover:bg-[rgba(0,255,102,0.18)] transition">
                  <f.icon className="w-7 h-7 text-[#00FF66]" strokeWidth={1.6} />
                </div>
                <h3 className="font-heading text-2xl font-bold text-white mb-3">
                  {t(f.titleKey)}
                </h3>
                <p className="text-[#9CA3AF] leading-relaxed text-sm">{t(f.textKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Facilities;
